import order from './modules/order';
import sales from './modules/sales';
import setting from './modules/setting';
import shop from './modules/shop';
import stock from './modules/stock';
import user from './modules/user';
import geekPay from './modules/geekPay';


/**
 * 在主框架内显示
 */

const frameIn = [{
        path: '/',
        redirect: {
            name: 'login'
        },
        component: () => import("@/pages/admin/layout/index.vue"),
        children: [{
                path: 'home',
                name: 'home',
                component: () => import("@/pages/admin/home/home.vue"),
                meta: {
                    title: '控制台 - 极客商城系统'
                }
            },
            order,
            sales,
            setting,
            shop,
            stock,
            user,
            geekPay
        ]
    },

];

/**
 * 在主框架之外显示
 */

const frameOut = [
    // 登录
    {
        path: '/login',
        name: 'login',
        component: () => import("@/pages/admin/account/login2.vue"),
        meta: {
            title: '管理员登录 - 极客商城系统'
        }
    },

];


/**
 * 错误页面
 */

const errorPage = [{
        path: '*',
        name: '404',
        meta: {
            title: '404'
        },
        component: () => import('@/pages/error/404')
    },
    {
        path: '/error',
        name: 'error',
        meta: {
            title: '程序未授权'
        },
        component: () => import('@/pages/error/auth')
    },
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [
    ...frameIn,
    ...frameOut,
    ...errorPage
];